<div class="mat-body confirm-dialog">
  <h1 mat-dialog-title>
    <sc-dictionary-label [dictionaryKey]="data.titleKey"></sc-dictionary-label>
  </h1>

  <mat-dialog-content>
    <div [innerHTML]="data.messageKey| translate: getMessageArgs() | trustHtml"></div>
  </mat-dialog-content>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex >
    <sc-content-spacer grow></sc-content-spacer>
    <button mat-stroked-button (click)="cancel()">
      <sc-dictionary-label dictionaryKey="shared.confirm-dialog.action.no"></sc-dictionary-label>
    </button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-flat-button (click)="confirm()">
      @if (data.confirmBtnKey != null) {
        <sc-dictionary-label [dictionaryKey]="data.confirmBtnKey"></sc-dictionary-label>
      }
      @if (data.confirmBtnKey == null) {
        <sc-dictionary-label dictionaryKey="shared.confirm-dialog.action.yes"></sc-dictionary-label>
      }
    </button>
  </sc-flex>

</div>
